import { createApp } from "vue";
import { createPinia } from "pinia";
import { createHead } from "@unhead/vue";
import vuetify from "./plugins/vuetify";

import App from "./App.vue";
import { getRouter } from "./router";
import { loadFonts } from "./plugins/webfontloader";
import "bootstrap/dist/css/bootstrap.min.css";
import "@/assets/main.css";

loadFonts();

const app = createApp(App);
const head = createHead();
const router = getRouter();

app.use(head);
app.use(vuetify);
app.use(createPinia());
app.use(router);

router.isReady().then(() => {
	app.mount("#app");
	requestAnimationFrame(() => {
		document.dispatchEvent(new Event("render-event"));
	});
});